import * as React from 'react'

import { PrivacyStyled } from './Privacy.style'

export const PrivacyView = () => {
  return <PrivacyStyled>Hello</PrivacyStyled>
}
